import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'
import HashHero from 'hash-heroes';

import gameContract from '../data/gameContract.js';
import {
    CONTRACT_ADDRESS_64,
    CONTRACT_ADDRESS_256,
    SIDE_LENGTH_16,
    SIDE_LENGTH_8 } from '../constants.js';
import MyHero from './MyHero';
import {
  Link
} from 'react-router-dom'
import './App.css';

export default class HashHeroList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            bigHashHeroes: [],
            smallHashHeroes: [],
            currentAddress: null,
        }
    }

    componentDidMount() {
        if (this.props.web3) {
            this.setup(this.props.web3);
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.web3) {
            this.setup(newProps.web3);
        }
    }

    setup = (web3) => {
        const accounts = web3.eth.accounts;
        const currentAddress = (accounts && accounts.length > 0) ? accounts[0] : '';
        this.setState({
            currentAddress,
        });
        const bigContract = web3.eth.contract(gameContract.abi).at(CONTRACT_ADDRESS_256);
        const smallContract = web3.eth.contract(gameContract.abi).at(CONTRACT_ADDRESS_64);
        this.getGameNum(bigContract).then((gameNumber) => {
            this.getHashHeroes(bigContract, SIDE_LENGTH_16, gameNumber);
        });
        this.getGameNum(smallContract).then((gameNumber) => {
            this.getHashHeroes(smallContract, SIDE_LENGTH_8, gameNumber);
        });

    }

    getGameNum = (contract) => {
        return new Promise((resolve, reject) => {
            contract.currentGameNumber.call((err, res) => {
                if (err) {
                    reject(err);
                }
                const gameNumber = res.toNumber();
                resolve(gameNumber);
            });
        });
    }

    getHashHeroes = (contract, sideLength, currentGameNumber) => {
        const hashHeroes = Array(currentGameNumber).fill("");
        let numHeroesReceived = 0;

        for (let i = 1; i < currentGameNumber; i++) {
            contract.gameToWinner.call(i, (err, res) => {
                hashHeroes[i] = res;
                numHeroesReceived += 1;

                if (numHeroesReceived === currentGameNumber - 1) {
                    if (sideLength === 16) {
                        this.setState({
                            bigHashHeroes: hashHeroes,
                        });
                    } else {
                        this.setState({
                            smallHashHeroes: hashHeroes,
                        });
                    }
                }
            });
        }
    }

    renderHeroLink = (boardSize) => (address, index) => {
        if (index === 0) {
            // our contract's game number starts at 1 so skip rendering 0
        }

        return (
            <Link className="win-hero" to={`/games/${boardSize}/${index}`}>
                <ReactTooltip
                    id={`heroes-${boardSize}-${index}`}
                    effect="solid"
                    offset={{ left: -44 }}
                >
                  <span>Game {index}</span>
                </ReactTooltip>
                <a data-tip data-for={`heroes-${boardSize}-${index}`}>
                    <HashHero seed={address} scalingFactor={5} />
                </a>
            </Link>
        )
    }

    render() {
        const { currentAddress } = this.state;
        return (
            <div className="container">
                <div className="header-bar">
                    <h1 className="game-title"> Hash Heroes </h1>
                    <Link className="hash-link" to="/"> See current game </Link>
                </div>
                { currentAddress && <MyHero seed={this.state.currentAddress} /> }
                <h3 className="list-title"> Previous 16x16 Champions </h3>
                <div className="heroes-card">
                    <h4> Click any winner to see the winning board state. </h4>
                    <div className="heroes-card-inner">
                        {this.state.bigHashHeroes.map(this.renderHeroLink(256))}
                    </div>
                </div>
                <h3 className="list-title"> Previous 8x8 Champions </h3>
                <div className="heroes-card">
                    <h4> Click any winner to see the winning board state. </h4>
                    <div className="heroes-card-inner">
                        {this.state.smallHashHeroes.map(this.renderHeroLink(64))}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/HashHeroList.js